import React from 'react'
import { Link } from 'gatsby'

import {
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem
} from '@elastic/eui'

import mqttApiCardIcon from '../../../images/Advanced_User/INSTAR_MQTT_Broker/toc_Card_mqtt_api.webp'
import mqttDebugCardIcon from '../../../images/Advanced_User/INSTAR_MQTT_Broker/toc_Card_mqtt_vs_http.webp'

export default function LatestArticle() {

  return (
    <React.Fragment>
      <EuiFlexItem>
        <EuiFlexGroup gutterSize="l" direction="row" >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/Advanced_User/INSTAR_MQTT_Broker/MQTT_API/">
                  <img
                    src={mqttApiCardIcon}
                    alt="INSTAR MQTT API"
                  />
                </Link>
              }
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/Advanced_User/INSTAR_MQTT_Broker/MQTT_vs_HTTP_API/">
                  <img
                    src={mqttDebugCardIcon}
                    alt="INSTAR MQTT - MQTT vs HTTP API"
                  />
                </Link>
              }
            />
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>
    </React.Fragment>
  );
}
